import { Directive, ElementRef, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { InfoTextService } from '../services/infotext.service';

@Directive({
  selector: '[uiInfotextAnchor]',
  standalone: true,
})
export class InfotextAnchorDirective implements OnInit, OnDestroy {
  private el = inject(ElementRef<HTMLElement>);
  private infotextService = inject(InfoTextService);

  @Input('uiInfotextAnchor') key!: string;

  ngOnInit() {
    if (this.key) {
      this.infotextService.register(this.key, this.el);
      this.el.nativeElement.setAttribute('uiInfotextAnchor', this.key);
    }
  }

  ngOnDestroy() {
    if (this.key) this.infotextService.unregister(this.key);
  }
}
